import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { routerTransition } from '../../shared/animations/router.animations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AdvisorData, AdvisorRouteData } from '../advisor.model';

@UntilDestroy()
@Component({
    selector: 'ifb-advisor-profile',
    templateUrl: './advisor-profile.component.html',
    styleUrls: ['./advisor-profile.component.css'],
    animations: routerTransition,
    standalone: false
})
export class AdvisorProfileComponent implements OnInit {
  data: AdvisorData;

  constructor(
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.data.pipe(untilDestroyed(this))
      .subscribe(this.dataSet.bind(this));
  }

  dataSet(data: AdvisorRouteData): void {
    this.data = data.advisor;
  }
}
